import { isInspectionInProgress } from '@/utils/isInspectionInProgress.util';

export const SW_CONTROLLER_RELOAD_SESSION_KEY = 'inspectSwControllerReloadAttempted';

/**
 * Reload once per session when uploads are pending but the page has no SW controller.
 */
export function tryAutoReloadForMissingServiceWorkerController(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  if (isInspectionInProgress(window.location.pathname)) {
    return false;
  }
  if (!('serviceWorker' in navigator) || navigator.serviceWorker.controller) {
    return false;
  }
  if (sessionStorage.getItem(SW_CONTROLLER_RELOAD_SESSION_KEY) === '1') {
    return false;
  }
  sessionStorage.setItem(SW_CONTROLLER_RELOAD_SESSION_KEY, '1');
  window.location.reload();
  return true;
}
